import React, { type ReactNode } from 'react';
import { cssMap, cx } from '@atlaskit/css';
import { Flex, Inline, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

type Props = {
	leftContent: ReactNode;
	rightContent: ReactNode;
	footer: ReactNode;
};

const styles = cssMap({
	container: {
		height: '100%',
		width: '100%',
	},
	inline: {
		overflow: 'hidden',
	},
	panel: {
		paddingBlock: token('space.250'),
		paddingInline: token('space.250'),
		overflow: 'hidden',
	},
	leftPanel: {
		flexBasis: '240px',
		borderRight: `${token('border.width')} solid ${token('color.border')}`,
	},
	rightPanel: {
		flex: 1,
	},
});

export const Layout = ({ leftContent, rightContent, footer }: Props) => (
	<Stack grow="fill" spread="space-between" xcss={styles.container}>
		<Inline alignBlock="stretch" grow="fill" xcss={styles.inline}>
			<Flex xcss={cx(styles.panel, styles.leftPanel)}>{leftContent}</Flex>
			<Flex xcss={cx(styles.panel, styles.rightPanel)}>{rightContent}</Flex>
		</Inline>
		{footer}
	</Stack>
);
